import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./weekly-order.module.css"

@tagName("")
export default class WeeklyOrderComponent extends Component {
  readonly styles = styles
}
